<template>
    <div class="tabs-navigation-menu">
        <RedesignBasePopover
            v-model="visible"
            trigger="click"
            :visible-arrow="false"
        >
            <template #reference>
                <div
                    class="flex items-center justify-center"
                    data-testid="button-group-menu"
                >
                    <redesign-base-icon
                        :size="16"
                        name="IconOptions"
                        class="flex items-center justify-center hover:text-active-elements--focus outline-none"
                    />
                </div>
            </template>
            <div class="tabs-navigation-menu__actions">
                <div
                    class="menu-action_item"
                    data-testid="menu-item-bulk-update-filters"
                    @click="onUpdateFiltersWidgetGroup"
                >
                    <redesign-base-icon
                        name="Filter"
                        :size="18"
                        class="text-primary-actions"
                    />
                    <span class="px-2 text-main-sm truncate">
                        {{ $t('dashboard.bulkUpdateFilters') }}
                    </span>
                </div>
                <div
                    class="menu-action_item"
                    data-testid="menu-item-copy-group"
                    @click="onCopyWidgetGroup"
                >
                    <redesign-base-icon
                        name="Files"
                        :size="18"
                        class="text-primary-actions"
                    />
                    <span class="px-2 text-main-sm truncate">
                        {{ $t('dashboard.copyGroup') }}
                    </span>
                </div>
                <div
                    :class="!isLastWidgetGroup ? 'menu-action_item' : 'menu-action_item_inactive'"
                    data-testid="menu-item-delete-group"
                    @click="onDeleteWidgetGroup"
                >
                    <redesign-base-icon
                        name="Trash2"
                        :size="18"
                        class="text-destructive-actions"
                        :class="{'text-inactive-elements' : isLastWidgetGroup}"
                    />
                    <span
                        class="px-2 text-main-sm truncate"
                        :class="{'text-inactive-elements' : isLastWidgetGroup}"
                    >
                        {{ $t('dashboard.deleteGroup') }}
                    </span>
                </div>
            </div>
        </RedesignBasePopover>
    </div>
</template>

<script setup lang="ts">
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { computed, ref } from 'vue'

interface IProps {
    numberOfWidgetGroup: number
}

const props = defineProps<IProps>()

const emit = defineEmits([ 'on-remove-widget-group', 'on-copy-widget-group', 'on-update-filters-widget-group' ])

const visible = ref(false)

const isLastWidgetGroup = computed(() => {
    return props.numberOfWidgetGroup === 1
})

function onUpdateFiltersWidgetGroup () {
    emit('on-update-filters-widget-group')
    visible.value = false
}

function onCopyWidgetGroup () {
    emit('on-copy-widget-group')
    visible.value = false
}

function onDeleteWidgetGroup () {
    if (!isLastWidgetGroup.value) {
        emit('on-remove-widget-group')
        visible.value = false
    }
}
</script>

<style lang="scss">
.tabs-navigation-menu {
    &__actions {
        @apply divide-y divide-ui-lines;
        .menu-action_item {
            @apply flex items-center p-2 cursor-pointer rounded-sm;
            color: var(--mainTextColor-color);
            transition: all .3s ease;

            &:hover {
                color: var(--active-elements);
                background-color: color-mix(in srgb, var(--primary-actions) 5%, transparent);
            }
        }
        .menu-action_item_inactive {
            @apply flex items-center p-2 cursor-not-allowed rounded-sm;
            color: var(--mainTextColor-color);
        }
    }
}
</style>
